import { ItemType } from 'antd/es/menu/interface';
import { Button, Dropdown, Space } from 'antd';
import { useMemo } from 'react';
import { Tooltip } from '../../../common/components';
import { PopconfirmDelete } from '../../../common/components/PopconfirmDelete';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import * as Icon from 'react-feather';
import translations from './AlgorithmsTableActionsDropdown.translations.json';
import { DropdownItem } from '../../../common/components/DropdownItem';

const { addTranslations, useTranslation } = i18nNsFactory(
  'algorithms-table-actions-dropdown',
);
addTranslations(translations);

interface AlgorithmsTableActionsDropdownProps {
  onClickDeleteSelected?: () => void;
  onClickTestRunSelected?: () => void;
  onClickCheckBrokenReferencesSelected?: () => void;
  onClickDisplayGraphically?: () => void;
  isDisplayGraphicallyDisabled?: boolean;
}

export function AlgorithmsTableActionsDropdown({
  onClickDeleteSelected,
  onClickTestRunSelected,
  onClickCheckBrokenReferencesSelected,
  onClickDisplayGraphically,
  isDisplayGraphicallyDisabled,
}: AlgorithmsTableActionsDropdownProps) {
  const { t } = useTranslation();

  const items: ItemType[] = useMemo(
    () => [
      ...(onClickDeleteSelected
        ? [
            {
              key: 'delete-selected',
              label: (
                <PopconfirmDelete
                  stopClickPropagation
                  onDelete={() => onClickDeleteSelected()}
                  genitiveModelName={t('delete-selected.genitive.description')}
                >
                  {t('button.delete-selected')}
                </PopconfirmDelete>
              ),
            },
          ]
        : []),
      ...(onClickDisplayGraphically
        ? [
            {
              key: 'display-graphically',
              label: (
                <Tooltip
                  title={
                    isDisplayGraphicallyDisabled
                      ? t('tooltip.display-graphically')
                      : undefined
                  }
                >
                  <DropdownItem>{t('button.display-graphically')}</DropdownItem>
                </Tooltip>
              ),
              disabled: isDisplayGraphicallyDisabled,
              onClick: onClickDisplayGraphically,
            },
          ]
        : []),
      ...(onClickTestRunSelected
        ? [
            {
              key: 'test-run-selected',
              label: (
                <DropdownItem onClick={onClickTestRunSelected}>
                  {t(`button.test-run-selected`)}
                </DropdownItem>
              ),
            },
          ]
        : []),
      ...(onClickCheckBrokenReferencesSelected
        ? [
            {
              key: 'check-broken-references-selected',
              label: (
                <DropdownItem onClick={onClickCheckBrokenReferencesSelected}>
                  {t(`button.check-broken-references-selected`)}
                </DropdownItem>
              ),
            },
          ]
        : []),
    ],
    [
      onClickDeleteSelected,
      t,
      onClickTestRunSelected,
      onClickCheckBrokenReferencesSelected,
      onClickDisplayGraphically,
      isDisplayGraphicallyDisabled,
    ],
  );

  return (
    <Dropdown menu={{ items }} trigger={['click']}>
      <Space>
        <Button id="algorithms-table-actions-dropdown-delete-selected-button">
          {t('button.actions')}
          <Icon.ChevronDown size={18} />
        </Button>
      </Space>
    </Dropdown>
  );
}
